"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RadialFade = exports.MeshBackground = void 0;
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const svg_1 = require("../svg/");
const styled_1 = __importDefault(require("../../styles/styled"));
const MeshBackgroundWrapper = styled_1.default.div({
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    position: 'absolute',
    left: '0',
    right: '0 ',
    top: '0',
    bottom: '0',
    minWidth: '1440px',
});
const ContentWrapper = styled_1.default.div({
    position: 'absolute',
    left: '0',
    right: '0 ',
    top: '0',
    bottom: '0',
});
const LinearGradientBackground = styled_1.default.div({
    position: 'relative',
    width: '100%',
    background: 'linear-gradient(90deg, #008CFF 0%, #00BFFF 57.47%, #23E5E5 100%)',
    height: '100vh',
});
const RadialGradientBackground = styled_1.default.div({
    background: 'rgba(0,160,255, .9)',
    borderRadius: '50%',
    zIndex: 0,
    boxShadow: '0 0 100px 100px rgba(0,160,255, .9)',
});
const MeshBackground = ({ children }) => {
    return ((0, jsx_runtime_1.jsxs)(LinearGradientBackground, { children: [(0, jsx_runtime_1.jsx)(MeshBackgroundWrapper, { children: (0, jsx_runtime_1.jsx)(svg_1.MeshBackgroundIcon, {}) }), (0, jsx_runtime_1.jsx)(ContentWrapper, { children: children })] }));
};
exports.MeshBackground = MeshBackground;
const RadialFade = ({ children }) => {
    return (0, jsx_runtime_1.jsx)(RadialGradientBackground, { children: children });
};
exports.RadialFade = RadialFade;
//# sourceMappingURL=index.js.map